<div class="push-notifications-container relative">
  <button
    id="push-notifications-trigger"
    type="button"
    class="push-notifications-trigger relative p-2 text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none dark:text-gray-400 dark:hover:bg-gray-700"
    (click)="toggleDropdown()"
  >
    <img [src]="images.user.notifications" alt="notifications" class="w-6 h-6" />
    <span
      *ngIf="unreadCount > 0"
      class="badge absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-[#8136db] rounded-full"
    >
      {{ unreadCount > 99 ? '99+' : unreadCount }}
    </span>
  </button>

  <div
    id="push-notifications-dropdown"
    class="dropdown-panel fixed right-0 top-20 w-96 bg-white shadow-lg dark:bg-gray-800 border border-gray-200 dark:border-gray-700 z-50"
    [ngClass]="{ hidden: !isOpen }"
  >
    <div class="header flex items-center justify-between px-4 py-3">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
        {{ literalService.get('pushNotifications.title') }}
      </h3>
      <button
        type="button"
        class="text-xs text-purple-700 hover:text-purple-900 dark:text-purple-300"
        (click)="markAllAsRead()"
        [disabled]="unreadCount === 0"
        [ngClass]="{ 'opacity-50 cursor-not-allowed': unreadCount === 0 }"
      >
        {{ literalService.get('pushNotifications.markAllAsRead') }}
      </button>
    </div>
    <div class="header-shadow"></div>

    <!-- Tabs hidden for now
    <div class="tabs-container">
      <div class="tabs flex">
        <button
          type="button"
          class="tab flex-1 px-4 py-2 text-sm font-medium text-center"
          [ngClass]="{
            'text-purple-600 border-b-2 border-purple-600': activeTab === 'all',
            'text-gray-500 hover:text-gray-700 dark:text-gray-400 border-b-2 border-transparent': activeTab !== 'all'
          }"
          (click)="setActiveTab('all')"
        >
          {{ literalService.get('pushNotifications.tabs.all') }}
        </button>
        <button
          type="button"
          class="tab flex-1 px-4 py-2 text-sm font-medium text-center"
          [ngClass]="{
            'text-purple-600 border-b-2 border-purple-600': activeTab === 'messages',
            'text-gray-500 hover:text-gray-700 dark:text-gray-400 border-b-2 border-transparent': activeTab !== 'messages'
          }"
          (click)="setActiveTab('messages')"
        >
          {{ literalService.get('pushNotifications.tabs.messages') }}
        </button>
        <button
          type="button"
          class="tab flex-1 px-4 py-2 text-sm font-medium text-center"
          [ngClass]="{
            'text-purple-600 border-b-2 border-purple-600': activeTab === 'trips',
            'text-gray-500 hover:text-gray-700 dark:text-gray-400 border-b-2 border-transparent': activeTab !== 'trips'
          }"
          (click)="setActiveTab('trips')"
        >
          {{ literalService.get('pushNotifications.tabs.trips') }}
        </button>
        <button
          type="button"
          class="tab flex-1 px-4 py-2 text-sm font-medium text-center"
          [ngClass]="{
            'text-purple-600 border-b-2 border-purple-600': activeTab === 'reviews',
            'text-gray-500 hover:text-gray-700 dark:text-gray-400 border-b-2 border-transparent': activeTab !== 'reviews'
          }"
          (click)="setActiveTab('reviews')"
        >
          {{ literalService.get('pushNotifications.tabs.reviews') }}
        </button>
      </div>
      <div class="tabs-shadow"></div>
    </div>
    -->

    <div class="notifications-list max-h-96 overflow-y-auto">
      <div *ngIf="loading" class="p-4 text-center text-gray-500 dark:text-gray-400">
        <img [src]="images.loading" alt="loading" class="w-8 h-8 mx-auto animate-spin" />
      </div>

      <div
        *ngIf="!loading && filteredNotifications.length === 0"
        class="p-8 text-center text-gray-500 dark:text-gray-400"
      >
        <p>{{ literalService.get('pushNotifications.empty') }}</p>
      </div>

      <div
        *ngFor="let notification of filteredNotifications"
        class="notification-item flex items-start p-4 border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
        [ngClass]="{
          'bg-blue-50 dark:bg-blue-900/20': !notification.read,
          'cursor-pointer': notification.redirectId
        }"
        (click)="onNotificationClick(notification)"
      >
        <div class="icon-container flex-shrink-0 mr-3 bg-[#8136db] rounded-full p-2">
          <img
            [src]="getIconForType(notification.redirectType)"
            alt="icon"
            class="w-5 h-5 brightness-0 invert"
          />
        </div>
        <div class="content flex-grow min-w-0">
          <p
            class="subject text-sm truncate"
            [ngClass]="{
              'font-bold text-gray-900 dark:text-white': !notification.read,
              'text-gray-700 dark:text-gray-300': notification.read
            }"
          >
            {{ notification.subject }}
          </p>
          <p
            class="preview text-xs truncate mt-1"
            [ngClass]="{
              'font-bold text-gray-700 dark:text-gray-300': !notification.read,
              'text-gray-500 dark:text-gray-400': notification.read
            }"
          >
            {{ notification.content }}
          </p>
          <p
            class="time text-xs mt-1"
            [ngClass]="{
              'font-medium text-gray-500 dark:text-gray-400': !notification.read,
              'text-gray-400 dark:text-gray-500': notification.read
            }"
          >
            {{ getRelativeTime(notification.dateTime) }}
          </p>
        </div>
        <div class="actions flex-shrink-0 ml-2">
          <button
            type="button"
            class="mark-read-btn p-1 rounded"
            [disabled]="notification.read"
            [ngClass]="{
              'cursor-not-allowed': notification.read,
              'hover:bg-gray-200 dark:hover:bg-gray-600': !notification.read
            }"
            (click)="toggleReadStatus(notification, $event)"
            [tooltip]="literalService.get('pushNotifications.markAsRead')"
            [visibleTooltip]="!notification.read"
            [position]="TooltipPosition.LEFT"
          >
            <img
              [src]="images.done"
              alt="toggle read"
              class="w-4 h-4"
              [style.filter]="notification.read ? 'invert(25%) sepia(98%) saturate(1654%) hue-rotate(251deg) brightness(87%) contrast(96%)' : ''"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
